import React, { useState, useEffect } from "react";
import NormalLayout from "../../components/layout/NormalLayout";
import axios from "axios";
import {
  Table,
  Tooltip,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Button,
} from "reactstrap";
import { orderStatus } from "../../utils/ConvertWord";
import Moment from "react-moment";
import ReactPaginate from "react-paginate";
import { AuthContext } from "../../context/AuthContext";
import { Cookies } from "react-cookie";
const cookies = new Cookies();

function Done() {
  const [data, setData] = useState(null);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0); // 전체 페이지 수
  const [dropdownOpen, setDropdownOpen] = useState(false); // 드롭다운의 열림/닫힘 상태
  const [pageSize, setPageSize] = useState(10); // 페이지당 노출수 설정
  const toggle = () => setDropdownOpen((prevState) => !prevState); // 드롭다운 상태 토글
  const [tooltipOpen, setTooltipOpen] = useState({});

  const toggleTooltip = (receiver) => {
    setTooltipOpen({
      ...tooltipOpen,
      [receiver]: !tooltipOpen[receiver],
    });
  };

  // 드롭다운에서 항목 선택 시, 페이지당 노출수 업데이트
  const selectPageSize = (size) => {
    setCurrentPage(0);
    setPageSize(size);
  };

  useEffect(() => {
    const excelListData = async () => {
      try {
        const encodedWholesaler = encodeURIComponent(
          cookies.get("info").profile
        );
        const resList = await axios.get(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/manage/order?status=DONE&page=${currentPage}&limit=${pageSize}&wholesaler=${encodedWholesaler}`,
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          }
        );
        if (resList.data.result === "success") {
          setData(resList.data.data.list);
          setCount(resList.data.data.count.count);
          setPageCount(Math.ceil(resList.data.data.count.count / pageSize));
        }
      } catch (error) {
        console.error("데이터를 불러오는데 실패했습니다", error);
      }
    };
    excelListData();
  }, [currentPage, pageSize]);

  // 페이지가 변경될 때마다 실행될 함수
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  // 주문건별 총 상품금액 계산함수
  const genAmount = (items, delivery_fee) => {
    let amount = 0.0;

    items.map((item) => {
      let price = convertPriceFormat(
        item.productCode,
        item.unitPrice,
        item.qauntity
      ).replace("$", "");
      if (!isNaN(price)) {
        amount += parseFloat(price);
      }
    });
    // 배송료 추가
    amount += parseFloat(delivery_fee);

    return amount.toFixed(2);
  };

  const convertPriceFormat = (productCode, unitPrice, qauntity) => {
    let resValue = null;
    let pcode = productCode.toUpperCase();

    // 예외처리 코드 : BRING, CHEMIST, MART, PROMO, SPECIAL, 공백
    if (pcode === "BRING" || pcode === "PROMO") {
      resValue = "$0";
    } else if (
      pcode === "CHEMIST" ||
      pcode === "MART" ||
      pcode === "SPECIAL" ||
      pcode === ""
    ) {
      resValue = "미정";
    } else {
      resValue =
        "$" +
        parseFloat(unitPrice * qauntity)
          .toFixed(2)
          .toString();
    }

    return resValue;
  };

  // 데이터를 요청된 형식으로 변환
  const formatData = (dataArray) => {
    return dataArray
      .map((order) => {
        return `${order.customer_name}\t${order.hawb}`;
      })
      .join("\n");
  };

  // 객체를 텍스트 파일로 다운로드하는 함수
  const downloadObjectAsTxt = () => {
    // 객체를 JSON 문자열로 변환 (들여쓰기 포함)
    // 데이터 포맷팅
    const formattedText = formatData(data);

    // Blob 객체 생성
    const blob = new Blob([formattedText], {
      type: "text/plain;charset=utf-8",
    });

    // 다운로드 URL 생성
    const url = URL.createObjectURL(blob);

    // 다운로드 링크 생성
    const link = document.createElement("a");
    link.href = url;
    link.download = "발송완료 리스트.txt"; // 다운로드 파일명

    // 링크 클릭하여 다운로드 시작
    document.body.appendChild(link);
    link.click();

    // 메모리 정리
    setTimeout(() => {
      URL.revokeObjectURL(url);
      document.body.removeChild(link);
    }, 100);
  };

  return (
    <NormalLayout>
      <div>
        <h3>발송완료 {count && count !== 0 ? <>({count}건)</> : <></>}</h3>
      </div>
      <div className="p-3"></div>
      {data ? (
        <>
          <div className="border p-3">
            <div className="mb-3">
              {/* <div className="text-center p-5  mb-3 border">검색 설정</div>{" "} */}

              <Row>
                <Col>
                  {" "}
                  <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret color="dark">
                      페이지당 노출 수: {pageSize}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => selectPageSize(10)}>
                        10개
                      </DropdownItem>
                      <DropdownItem onClick={() => selectPageSize(30)}>
                        30개
                      </DropdownItem>
                      <DropdownItem onClick={() => selectPageSize(50)}>
                        50개
                      </DropdownItem>
                      <DropdownItem onClick={() => selectPageSize(100)}>
                        100개
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>{" "}
                </Col>
                <Col className="text-end">
                  <Button onClick={downloadObjectAsTxt} color="primary">
                    발송완료건 다운로드
                  </Button>
                </Col>
              </Row>
            </div>
            <Table hover bordered>
              <thead>
                <tr className="table-primary">
                  <th className="text-center p-2 border">주문번호</th>
                  <th className="text-center p-2 border">등록일</th>
                  <th className="text-center p-2 border">출고일</th>
                  <th className="text-center p-2 border">요청메모</th>
                  <th className="text-center p-2 border">이름</th>
                  {/* <th className="text-center p-2 border">전화번호</th>
                  <th className="text-center p-2 border">모바일번호</th>
                  <th className="text-center p-2 border">통관부호</th>
                  <th className="text-center p-2 border">우편번호</th>
                  <th className="text-center p-2 border">주소</th> */}
                  <th className="text-center p-2 border">배송메모</th>
                  <th className="text-center p-2 border">주문상품</th>

                  <th className="text-center p-2 border">무게</th>
                  <th className="text-center p-2 border">배송료</th>
                  <th className="text-center p-2 border">총액</th>
                  <th className="text-center p-2 border">운송장번호</th>
                </tr>
              </thead>
              <tbody>
                {data.map((o, idx) => {
                  return (
                    <tr key={idx}>
                      <td className="text-center cell">{o.order_no}</td>
                      <td className="text-center">
                        <Moment format="YYYY-MM-DD">{o.created_at}</Moment>
                      </td>
                      <td className="text-center">
                        <Moment format="YYYY-MM-DD">{o.delivery_at}</Moment>
                      </td>
                      <td className="text-center cell">{o.shipper_memo}</td>
                      <td className="text-center" style={{ cursor: "pointer" }}>
                        {" "}
                        <span id={`Tooltip-${o.order_index}`}>
                          {" "}
                          {o.customer_name}
                        </span>
                        <Tooltip
                          placement="top"
                          isOpen={tooltipOpen[o.order_index]}
                          target={`Tooltip-${o.order_index}`}
                          toggle={() => toggleTooltip(o.order_index)}
                        >
                          <div className="text-start">
                            <li>통관부호 : {o.pcc}</li>
                            <li>전화번호 : {o.customer_tel}</li>
                            <li>모바일 : {o.customer_mobile}</li>
                            <li>
                              주소 : {o.address}, #{o.zip}
                            </li>
                          </div>
                        </Tooltip>
                      </td>
                      {/* <td className="text-center">{o.customer_tel}</td>
                      <td className="text-center">{o.customer_mobile}</td>
                      <td className="text-center">{o.pcc}</td>
                      <td className="text-center">{o.zip}</td>
                      <td>{o.address}</td> */}
                      <td>{o.delivery_memo}</td>
                      <td style={{ padding: "0px" }}>
                        <Table
                          bordered
                          style={{ margin: "0px", width: "100%" }}
                        >
                          <tbody>
                            {o.order_product.map((i, index) => {
                              return (
                                <tr key={index}>
                                  <td
                                    className="text-center"
                                    style={{ width: "70px" }}
                                  >
                                    {i.productCode}
                                  </td>

                                  <td className="cell">{i.productName}</td>
                                  <td
                                    style={{ width: "60px" }}
                                    className="text-center"
                                  >
                                    {i.qauntity}개
                                  </td>
                                  <td
                                    style={{ width: "70px" }}
                                    className="text-center"
                                  >
                                    {convertPriceFormat(
                                      i.productCode,
                                      i.unitPrice,
                                      i.qauntity
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </td>
                      <td className="text-center">{o.weight}</td>
                      <td className="text-center">{o.delivery_fee}</td>
                      <td className="text-center">
                        ${genAmount(o.order_product, o.delivery_fee)}
                      </td>
                      <td className="text-center">
                        <a
                          href={
                            "https://service.epost.go.kr/trace.RetrieveDomRigiTraceList.comm?sid1=" +
                            o.hawb
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          {o.hawb}
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <ReactPaginate
                previousLabel={"이전"}
                nextLabel={"다음"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"item active "}
                breakClassName={"item break-me "}
                pageClassName={"item pagination-page "}
                disabledClassName={"disabled-page"}
              />
            </div>
          </div>
        </>
      ) : (
        <>주문 데이터 없음</>
      )}
    </NormalLayout>
  );
}

export default Done;
